import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const login = async (email: string, password: string) => {
  const response = await api.post('/auth/login', { email, password });
  return response.data;
};

export const register = async (email: string, password: string, name: string) => {
  const response = await api.post('/auth/register', { email, password, name });
  return response.data;
};

export const getProfile = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

export const generateContent = async (title: string, type: string, prompt: string) => {
  const response = await api.post('/content/generate', { title, type, prompt });
  return response.data;
};

export const getContentHistory = async (page: number = 1, type?: string) => {
  const params: any = { page, limit: 10 };
  if (type) params.type = type;
  const response = await api.get('/content/history', { params });
  return response.data;
};

export const getContent = async (id: string) => {
  const response = await api.get(`/content/${id}`);
  return response.data;
};

export const deleteContent = async (id: string) => {
  const response = await api.delete(`/content/${id}`);
  return response.data;
};

export const createCheckoutSession = async (tier: string) => {
  const response = await api.post('/subscription/create-checkout', { tier });
  return response.data;
};

export const cancelSubscription = async () => {
  const response = await api.post('/subscription/cancel');
  return response.data;
};